import { InputAdornment, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { ValidateMatchParam } from '../../types'
import matchHelper from '../../helpers/match.helper'
import ActionButtonsGroup from '../containers/ActionButtonsGroup'

interface InputBaseMatchSearchProps {
    updateParams: (search: string, matchParams: ValidateMatchParam) => void
}

export default function InputBaseMatchSearch({ updateParams }: Readonly<InputBaseMatchSearchProps>) {
    const [search, setSearch] = useState('')
    const [matchParams, setMatchParams] = useState<ValidateMatchParam>(matchHelper.matchParamsDefault)

    useEffect(() => {
        updateParams(search, matchParams)
    }, [search, matchParams])

    return (
        <TextField
            label="Búsqueda (3 letras min)"
            value={search}
            size='small'
            variant='standard'
            onChange={e => setSearch(e.target.value)}
            fullWidth
            InputProps={{
                endAdornment: <InputAdornment position="end">
                    <ActionButtonsGroup
                        className='m-r-auto'
                        variant='text'
                        items={[
                            {
                                title: 'Case Sensitive',
                                label: 'Aa',
                                style: { textTransform: 'none', padding: 0 },
                                color: matchParams.caseSensitive ? 'secondary' : 'primary',
                                action: () => setMatchParams(state => ({ ...state, caseSensitive: !state.caseSensitive }))
                            },
                            {
                                title: 'Limpiar',
                                icon: 'times',
                                style: { padding: 0 },
                                action: () => setSearch('')
                            }
                        ]}
                    />
                </InputAdornment>
            }}
        />
    )
}
